import { notification } from '@pu/mpp-ui/notifications';
import { NOTIFICATIONS_FOR_PURCHASE_INCREMENT } from 'core/constants/products.constants';

interface IPurchaseIncrementAppliedHandlerParams {
  purchaseIncrement: number;
  notificationsFired?: number;
  onNotify: () => void;
}

export const purchaseIncrementAppliedHandler =
  ({ purchaseIncrement, notificationsFired = 0, onNotify }: IPurchaseIncrementAppliedHandlerParams) =>
  (adjustedQty: number | undefined) => {
    if (notificationsFired >= NOTIFICATIONS_FOR_PURCHASE_INCREMENT || adjustedQty === 0) return;

    onNotify();
    notification.success(
      `Este producto se vende de ${purchaseIncrement} en ${purchaseIncrement}. Ahora tienes ${adjustedQty} unidades en tu carrito.`,
    );
  };
